/** Compare date evidence without allowing missing or invalid dates to lead. */
export function compareDatesNewestFirst(left: string | null | undefined, right: string | null | undefined): number {
  const leftTime = left ? Date.parse(left) : NaN;
  const rightTime = right ? Date.parse(right) : NaN;
  if (!Number.isFinite(leftTime)) return Number.isFinite(rightTime) ? 1 : 0;
  if (!Number.isFinite(rightTime)) return -1;
  return rightTime - leftTime;
}

export function newestFirst<Row>(rows: readonly Row[], date: (row: Row) => string | null | undefined): Row[] {
  return [...rows].sort((left, right) => compareDatesNewestFirst(date(left), date(right)));
}
